import { SITE_ROUTER as CORP_SITE_ROUTER } from '@libs/shared';
import ROUTER from './router';
import { createAPIProxy } from './utils/api';

const SITE_ROUTER = {
    ...CORP_SITE_ROUTER,
    // 工作台
    DASHBOARD: '/dashboard',
    // 应用URL
    APP_URL: '/dashboard#/app/:appId',
    // 模板中心
    SOLUTION_CENTER: '/tpl/center',
    // 产品模板中心详情页
    SOLUTION_CENTER_DETAIL: '/tpl/space/:spaceId/detail/:dataId',
    // 模板外链
    TEMPLATE_LINK: '/template/:appId',
    // AI助理
    AI_ASSISTANT: '/ai/ai_assistant',
    // 开放平台
    OPEN_PLATFORM_UNIT: '/open#/manage/plugin',
    OPEN_PLATFORM_PRIVATE_PLUGIN: '/open#/dev/private_plugin',
    OPEN_PLATFORM_MARKET: '/open#/market',
    OPEN_PLATFORM: '/open',
    OPEN_PLATFORM_PUBLISH: '/open/owner/plugin',
    OPEN_STORE_PLUGIN: '/open/store/plugin',
    OPEN_API_PARAMETER: '/open/open_api/parameter',
    OPEN_DATA_SOURCE: `/open#${ROUTER.OPEN.MANAGE_DATA_SOURCE}`,
    KMS: {
        HOME: '/spaces',
        SPACE: '/space/:spaceId'
    },
    APP_FROM_DESIGN: '/dashboard/app/:appId/form/:entryId/edit',
    APP_SETTING_SYNC_TABLE: '/dashboard/app/:appId/settings#/app_sync_table'
};

/**
 * @deprecated 旧路由表仅保留兼容存量调用。
 * 新增或迁移路由请使用 `SiteRouterKey + siteRouterManager`，
 * 不要在业务代码中继续直接读取 `SITE_ROUTER.xxx`。
 * @see libs/shared/src/utils/site-router.ts
 */
export default createAPIProxy(SITE_ROUTER);
